import React, { useContext } from 'react';
import { cookieExist, setCookie } from './browser-cookies';
import { AppContext } from '../Store';
import { COOKIE_NOTIFICATION_NAME, COOKIE_NOTIFICATION_VALUE_REJECT, COOKIE_NOTIFICATION_EXPIRATION_DATE } from './cookie-overlay';

export const withIppButtons = function(Component) {
	const EnhancedComponent = function({ ...props }) {
		
		const dispatch = useContext(AppContext)[1];

		const handleIppLinkClick = (e, ippLink, fromLogin = false) => {
			e.preventDefault();
			if (!fromLogin && !cookieExist(COOKIE_NOTIFICATION_NAME)){
				setCookie(COOKIE_NOTIFICATION_NAME, COOKIE_NOTIFICATION_VALUE_REJECT, COOKIE_NOTIFICATION_EXPIRATION_DATE);
				dispatch({ type: 'HIDE_COOKIE_OVERLAY' });
			}
			window.top.location.href = ippLink;
		};

		return (
			<Component
				{...props}
				handleIppLinkClick={handleIppLinkClick}
			/>
		);
	};
	EnhancedComponent.displayName = 'componentWithIppButtonsInForm';
	return EnhancedComponent;
};